import * as React from 'react'
import { InvoiceHeaderItemProps, useItemStyles } from './InvoiceOverview'
import MoneyText from '../../../components/Text/Currency/MoneyText'
import BaseOverviewCountBadge from '../../BaseOverview/BaseOverviewCountBadge'
import InvoiceListItemTurnover from './InvoiceListItemTurnover'

export default function InvoiceHeaderItem(props: InvoiceHeaderItemProps) {
    const itemStyles = useItemStyles()

    if (props.viewportNarrow) {
        return (
            <>
                <BaseOverviewCountBadge {...props} />
                <div className={itemStyles.listInvoiceItemNarrowBottomRow}>
                    <div></div>
                    <div></div>
                    {!props.viewportNarrow && <div></div>}
                    {!props.viewportNarrow && <div></div>}
                    <div>
                        <InvoiceListItemTurnover {...props} />
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <BaseOverviewCountBadge {...props} />
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div>
                <InvoiceListItemTurnover {...props} />
            </div>
            {!props.viewportMedium && <div></div>}
            {!props.viewportMedium && (
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <MoneyText
                            key={index}
                            value={{
                                currency: currency.currency,
                                amount: currency.outstandingTotal || '0.00',
                            }}
                            textProps={{
                                size: 300,
                            }}
                            align="right"
                        />
                    ))}
                </div>
            )}
            <div></div>
            <div></div>
        </>
    )
}
